// import { whiteLabelConstants } from '../';
import { entityList } from '../base/entity/reducers/list.reducers';
let options = {};
options.resourceName = 'whiteLabel';
// const whiteLabelReducer = new BaseReducer(options);
export const whiteLabelEntity = (state = {}, action) => {
    action.resourceName = "whiteLabel";
    return entityList(state, action)
};